<sh-toggle [label]="label()" [attr.active]="active() ? true : null" [disabled]="disabled()"></sh-toggle>
